import { Component, EventEmitter, Input, Output } from '@angular/core';
import { promoterType } from '../../constants/constants';
import * as tooltips from '../../constants/tooltips';
import { isFileConnectionType } from '../../utils/connection-type.util';
import { ConnectionFamilyType } from '../../models/connection-type';

@Component({
    selector: 'cdp-promoter-type-select',
    templateUrl: './promoter-type-select.component.html',
    styleUrl: './promoter-type-select.component.scss',
    standalone: false
})
export class PromoterTypeSelectComponent {
    @Input() promoterType: string;
    @Input() isBulk: boolean;
    @Input() disabled: boolean;
    @Output() promoterTypeChange = new EventEmitter<any>();
    _connectionFamily: ConnectionFamilyType | null;
    @Input() set connectionFamily(value: ConnectionFamilyType | null) {
        this._connectionFamily = value;
        this.promoterTypeOptions = Object.values(promoterType).filter(
            p => !p.isFileSourceTypeOnly || isFileConnectionType(this._connectionFamily)
        );
    }
    promoterTypeOptions: { name: string; value: string; description: string; isFileSourceTypeOnly: boolean }[] = [];

    tooltips = tooltips;

    onChangePromoterType(selection: any) {
        this.promoterTypeChange.emit(selection);
    }
}
